import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid, useTheme } from '@mui/material';
import { withNavbar } from '../../app/layout/HOC';
import UserProfileTabs from './UserProfileTabs';

const styles = {
  root: {
    flexGrow: 1,
    marginTop: 12.5,
  } as const
};

function UserProfilePage() {

  const { adminStore} = useStore();
  const {
    setActiveTab,
  } = adminStore;

  // const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isMobile = useMediaQuery('(min-width:900px)');
  return (
    <Grid sx={styles.root}>
      <Grid item>
        <UserProfileTabs setActiveTab={setActiveTab} isMobile={isMobile} />
      </Grid>
    </Grid>
  );
}

const UserProfile = withNavbar(observer(UserProfilePage));
export default UserProfile;